export default "__VITE_ASSET__DORGxZVn__"